import { IAddUpdateEmendaParlamentarRequest } from "../../../../model/admin-portal/request/add-update-emenda-parlamentar-request";
import { IEmendaParlamentarResponse } from "../../../../model/admin-portal/response/emenda-parlamentar-response";
import { IOrgaoResponse } from "../../../../model/admin-portal/response/orgao-response";
import { ITipoEmendaResponse } from "../../../../model/admin-portal/response/tipo-emenda-response";
import { IFormaRepasseEmendaResponse } from "../../../../model/admin-portal/response/forma-repasse-emenda-response";
import { IFuncaoGovernoResponse } from "../../../../model/admin-portal/response/funcao-governo-response";
import { IConvenioLookupResponse } from "../../../../model/admin-portal/response/convenio-lookup-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type EmendasParlamentaresState = {
    dataPaginatedListResponse: PaginationResponse<IEmendaParlamentarResponse>;
    isLoadingData: boolean;
    dataResponse: IEmendaParlamentarResponse | null;
    dataRequest: IAddUpdateEmendaParlamentarRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    orgaosList: IOrgaoResponse[];
    tiposList: ITipoEmendaResponse[];
    formasRepasseList: IFormaRepasseEmendaResponse[];
    funcoesGovernoList: IFuncaoGovernoResponse[];
    conveniosList: IConvenioLookupResponse[];
};

export const initialDataRequest: IAddUpdateEmendaParlamentarRequest = {
    id: null,
    idOrgao: null,
    idTipoEmenda: null,
    idFormaRepasseEmenda: null,
    idFuncaoGoverno: null,
    idConvenio: null,
    tipoOrigem: '',
    numeroEmenda: '',
    nomAutor: '',
    textoObjetoEmenda: '',
    ano: new Date().getFullYear(),
    valorPrevisto: 0,
    valorRealizado: 0
};

export const initialState: EmendasParlamentaresState = {
    dataPaginatedListResponse: new PaginationResponse<IEmendaParlamentarResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    orgaosList: [],
    tiposList: [],
    formasRepasseList: [],
    funcoesGovernoList: [],
    conveniosList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setOrgaosList = 'setOrgaosList',
    setTiposList = 'setTiposList',
    setFormasRepasseList = 'setFormasRepasseList',
    setFuncoesGovernoList = 'setFuncoesGovernoList',
    setConveniosList = 'setConveniosList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IEmendaParlamentarResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IEmendaParlamentarResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateEmendaParlamentarRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setOrgaosList; payload: IOrgaoResponse[] }
    | { type: ACTION_TYPES.setTiposList; payload: ITipoEmendaResponse[] }
    | { type: ACTION_TYPES.setFormasRepasseList; payload: IFormaRepasseEmendaResponse[] }
    | { type: ACTION_TYPES.setFuncoesGovernoList; payload: IFuncaoGovernoResponse[] }
    | { type: ACTION_TYPES.setConveniosList; payload: IConvenioLookupResponse[] };

export const emendasParlamentaresReducer = (state: EmendasParlamentaresState, action: Action): EmendasParlamentaresState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setOrgaosList:
            return { ...state, orgaosList: action.payload };
        case ACTION_TYPES.setTiposList:
            return { ...state, tiposList: action.payload };
        case ACTION_TYPES.setFormasRepasseList:
            return { ...state, formasRepasseList: action.payload };
        case ACTION_TYPES.setFuncoesGovernoList:
            return { ...state, funcoesGovernoList: action.payload };
        case ACTION_TYPES.setConveniosList:
            return { ...state, conveniosList: action.payload };
        default:
            return state;
    }
};
